import { render, staticRenderFns } from "./ManageFile.vue?vue&type=template&id=4ae5043b&scoped=true"
import script from "./ManageFile.vue?vue&type=script&lang=js"
export * from "./ManageFile.vue?vue&type=script&lang=js"
import style0 from "./ManageFile.vue?vue&type=style&index=0&id=4ae5043b&prod&scoped=true&lang=css"
import style1 from "./ManageFile.vue?vue&type=style&index=1&id=4ae5043b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae5043b",
  null
  
)

export default component.exports